module.exports = __webpack_public_path__ + "static/media/icon.f9d2642e.svg";